import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'COIN_UPDATE',
    smsDelete : 'COIN_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        coin: [],

        submitSuccess: false,
        coinLoading: false,
        coinError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_COIN(state, coin) {
            state.coin = coin;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        COIN_LOADING (state, loading) {
            state.coinLoading = loading;
        },

        COIN_ERROR (state, hasError) {
            state.coinError = hasError;
        }
    },

    actions: {
        async addCoin ({commit, dispatch}, payload) {
            commit('COIN_LOADING', true);
            commit('COIN_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_coin, payload.coin, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCoin')
                return response

            } catch (e) {
                commit('COIN_ERROR', true);
            } finally {
                commit('COIN_LOADING', false);
            }
        },

        async fetchCoin ({ commit }) {
            commit('COIN_LOADING', true);
            commit('COIN_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.coin_list, config);
                let response = result.data
                commit('SET_COIN', response.response);

            } catch(error) {
                commit('COIN_ERROR', true);
            } finally {
                commit('COIN_LOADING', false);
            }
        },

        async updateCoin ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.put(V1API.update_coin + payload.id, payload.coin, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCoin')
                return response

            } catch (e) {
                commit('COIN_ERROR', true);
            } finally {
                commit('COIN_LOADING', false);
            }
        },
        
        async deleteCoin({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.coin_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCoin')
            return response
        }
    },

    getters: {}
}
